import React, { useEffect, useState } from 'react'
import { Modal, Form, Row, Col, Input } from 'antd'
import closeIcon from 'assets/Images/close.svg'
import { AddOrgDocsPayload, OrgDocumentResp } from 'types/event/eventStep5'
import { creationEventStore } from 'state/event/eventCreationStore'
import UploadDocument from 'components/global/UploadDocument'
import ButtonSpinner from 'components/global/ButtonSpinner'
import {
  useAddOrgDocument,
  useUpdateOrgDocument,
} from 'api/EventCreation/creationStep5'
import { infoMessage } from 'api/global'
interface AddNewDocProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
  data?: OrgDocumentResp
}

const AddNewDoc: React.FC<AddNewDocProps> = ({
  openModal,
  closeModal,
  data,
}) => {
  const [form] = Form.useForm()
  const [documentIds, setDocumentIds] = useState<string[]>([])
  const [documents, setDocuments] = useState<any[]>([])
  const { organizationId } = creationEventStore(store => store.eventData)
  const { mutate: orgDocMutate, isLoading: orgDocLoading } = useAddOrgDocument()
  const { mutate: updateDoc, isLoading: updateDocLoading } =
    useUpdateOrgDocument()

  const formSchema = {
    name: data ? data.name : undefined,
    description: data ? data.description : undefined,
  }
  const handleCancel = () => {
    closeModal(false)
  }

  const onFinish = (values: AddOrgDocsPayload) => {
    // if (documentIds.length === 0) {
    //   return infoMessage('Document must be added')
    // }
    const payload = {
      ...values,
      organizationId,
      isDefault: false,
      fileId: documentIds[0],
    }
    if (data) {
      updateDoc(
        { payload, typeId: data._id },
        {
          onSuccess: () => handleCancel(),
        },
      )
    } else {
      orgDocMutate(payload, {
        onSuccess: () => handleCancel(),
      })
    }
  }

  useEffect(() => {
    if (data) {
      setDocumentIds([data.fileId])
      setDocuments([data.file])
    }
  }, [data])
  return (
    <div>
      <Modal
        open={openModal}
        onCancel={handleCancel}
        className="items-add-question"
        footer={false}
        width={600}
        maskClosable={false}
        centered
      >
        <div className="flex-center pt-20px justify-between ">
          <h2 className="w-600 text-18">Add document</h2>
          <img
            src={closeIcon}
            alt="close-button"
            onClick={handleCancel}
            className="close button pointer"
          />
        </div>
        <div className="mt-20px">
          <Form
            form={form}
            layout="vertical"
            initialValues={formSchema}
            onFinish={onFinish}
          >
            <Row gutter={10}>
              <Col>
                <label className="input-label required-input">Name</label>
                <Form.Item
                  className="form-control"
                  name="name"
                  rules={[{ required: true, message: 'Title is required' }]}
                >
                  <Input
                    className="question-field"
                    placeholder="Enter name of document"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col>
                <label className="input-label required-input">
                  Description
                </label>
                <Form.Item
                  className="form-control"
                  name="description"
                  rules={[
                    { required: true, message: 'Description is required' },
                  ]}
                >
                  <Input.TextArea
                    className="answer-field"
                    placeholder="Enter short description"
                    autoSize={{ minRows: 5, maxRows: 8 }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="relative">
              <label className="input-label">
                Upload document
              </label>
              <UploadDocument
                documentIds={documentIds}
                setDocumentIds={setDocumentIds}
                multiple={false}
                docType=".pdf,.doc,.docx,.txt"
                files={documents}
              />
            </div>
            <Row className="mt-10px justify-end">
              <button className="confirm-btn" type="submit">
                {orgDocLoading || updateDocLoading ? (
                  <ButtonSpinner size={20} color="#000" />
                ) : (
                  'Save'
                )}
              </button>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default AddNewDoc
